<template>
  <v-container>
    <v-card class="mx-auto mt-16 py-2 px-6" max-width="400">
      <v-card-item>
        <v-card-title>
          Sign in
        </v-card-title>
      </v-card-item>
      <!-- <v-card-text>
        We will periodically be opening access
      </v-card-text> -->
      <v-form>
        <v-text-field
          v-model="usernameInput"
          name="username"
          label="Username"
          type="text"
          placeholder="Username"
          variant="outlined"
          required
          :rules="emailRules"
        ></v-text-field>
        
        <v-text-field
          v-model="passwordInput"
          name="password"
          label="Password"
          type="password"
          placeholder="password"
          required
          variant="outlined"
          :rules="passwordRules"
          @keydown.enter="signin"
        ></v-text-field>
      </v-form>
      <v-card-actions>
        <v-btn
          @click="signin"
          text="Go"
        ></v-btn>
        <v-spacer/>
        <v-checkbox
          v-model="rememberInput"
          label="Remember me"
          density="compact"
          hide-details
          class="mt-0"
          @keydown.enter="signin"
        ></v-checkbox>
      </v-card-actions>
    </v-card>
    <div class="mx-auto mt-8 pa-2 access-text">
      <p>If you don't have an account, you can <router-link to="/register">register here</router-link>.
      </p>
    </div>
  </v-container>
</template>
<script lang="ts">
// import { checkEmail } from '@/utils/general'
import { Options, Vue } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import { useRouter } from 'vue-router'


export function checkEmail(v: string) {
  return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(v)
}

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapState(['username', 'rememberUser', 'authenticated'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    authenticated(value: boolean) {
      if (value) {
        this.$router.push('/stonks')
      } else {
        if (this.rememberMe && this.username != null) {
          this.usernameInput = this.username
        }
      }
    }
  }
})
export default class SignInView extends Vue {
  public breakpoint!: string
  public authenticated!: boolean
  public username!: string
  public rememberUser!: boolean
  public usernameInput: string = ''
  public passwordInput: string = ''
  public rememberInput: boolean | null = false
  public authFailureMessage: string = ''
  public router = useRouter()

  get rememberMe(): boolean {
    return this.rememberUser ?? this.rememberInput ?? false
  }

  set rememberMe(value: boolean) {
    this.rememberInput = value
  }

  public emailRules = [
    (v: string) => !!v || 'Email is required',
    (v: string) => !checkEmail(v) || 'Username is not an email address.',
  ]

  public passwordRules = [
    (v: string) => !!v || 'Password is required'
  ]

  public async mounted() {
    await this.$store.dispatch('checkAuth')
    if (this.rememberMe && this.username != null) {
      this.rememberInput = this.rememberMe
      this.usernameInput = this.username
    }
  }

  // get usernameModel(): string {
  //   return this.usernameInput
  // }

  // set usernameModel(value: string) {
  //   this.usernameInput = value
  // }
  
  public async signin() {
    // sign in here
    await this.$store.dispatch('authenticate', { username: this.usernameInput, password: this.passwordInput, remember: this.rememberInput })
    this.passwordInput = ''
    // this.router.push('/')
  }
}
</script>
<style lang="scss">
.access-text {
  max-width: 400px;
}
</style>